import {CTManagerItem} from "./ct-manager-item";

export class ItemFile {

  Oid: number | null = null;
  Name: string | null = null;
  CreateAt: Date | null = null;

  constructor(
    public File: File | null = null,
    public Item: CTManagerItem | null = null
  ) {

    if (File) {

      this.Name = File.name;

    }

  }

}
